module.exports = __webpack_public_path__ + "img/banner_code.2c1baa1c.png";